// extracted by mini-css-extract-plugin
export var active = "onboard-module--active--1d0dc";
export var bodyFont = "onboard-module--body-font--a31be";
export var onboard = "onboard-module--onboard--b0f12";
export var onboard_wrapper = "onboard-module--onboard_wrapper--89053";
export var switcher = "onboard-module--switcher--14b9e";
export var titleFont = "onboard-module--title-font--a468c";